
import {Stack, Typography} from '@mui/material'

import {useTranslation} from "react-i18next";
import mobileClasses from "./mobile.module.css";
import React, {useState} from "react";

import VarietySelect from "@/pages/components/VarietySelect";
import {useNavigate} from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";
import useSonicMigrateIntercept from "@/hook/useSonicMigrateIntercept";
const VarietyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const { showAppStoreModal, setShowAppStoreModal, interceptAction } = useSonicMigrateIntercept();

  return (<>
    <Stack className={mobileClasses.root}>
      <Stack
        sx={{height: '44px'}}
        direction="row" alignItems="center" justifyContent="space-between">
        <PageBack
          onClick={() => {
            navigate(-1, {replace: true})
          }}
          showTitle={false}
        />
      </Stack>
      <Typography sx={(theme) => ({ fontSize: theme.typography.pxToRem(28) })} className={mobileClasses.title}>{t('select_a_assets')}</Typography>
      <VarietySelect onSelect={() => {
        interceptAction();
      }} />
    </Stack>
    <OpenOrDownloadApp
      open={showAppStoreModal}
      onClose={() => setShowAppStoreModal(false)}
    />
  </>)
}

export default VarietyPage;